import { getCostCenterExpensesSummary } from '@api/cost-centers';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

export const useCostCenterExpensesSummary = () => {
  const { costCenterId } = useParams<{ costCenterId: string }>();
  const { data, isLoading } = useQuery({
    queryKey: ['cost-center-expenses-summary', costCenterId],
    queryFn: () => getCostCenterExpensesSummary(costCenterId!),
    enabled: !!costCenterId,
  });

  return {
    costCenterId,
    isLoading,
    data,
  };
};
